import clsx from 'clsx';
import urlBuilder from '@sanity/image-url';
import {SanityHomepage} from '~/types/sanityTypes';
import {useSanityClient} from '~/lib/utils';
import {InternalLink} from './index';
import useSanityData from '~/lib/useSanityData';
import {IconTagLine} from '../index';

export function HomepageHeader({
  page: serverPage,
  sanityQuery,
  sanityParams,
  className,
}: {
  page: SanityHomepage;
  sanityQuery: string;
  sanityParams: {slug: string};
  className?: string;
}) {
  const styles = clsx(
    'home-header',
    'relative grid grid-cols-1 md:h-drawer-height lg:grid-cols-home-header',
    className,
  );

  const page = useSanityData(serverPage, sanityQuery, sanityParams);

  if (page.hero && page.hero.title) {
    return (
      <div className={styles}>
        <div className="grid lg:min-w-[500px]">
          <div className="container z-20 bg-bgDark relative text-white py-16 flex flex-col justify-end">
            <h1 className="text-3xl md:text-4xl break-words">
              {page.hero.title}
            </h1>
            {page.hero.text && <p className="text-sm ">{page.hero.text}</p>}
            {page.hero.variant == 'callToAction' && (
              <div className="button-link-secondary">
                {page.hero.callToAction.link._type == 'linkInternal' && (
                  <InternalLink
                    documentType={page.hero.callToAction.link.documentType}
                    slug={page.hero.callToAction.link.slug}
                  >
                    {page.hero.callToAction.link.title}
                  </InternalLink>
                )}
                {page.hero.callToAction.link._type == 'linkExternal' && (
                  <a
                    href={page.hero.callToAction.link.url}
                    target={
                      page.hero.callToAction.link.newWindow ? '_blank' : ''
                    }
                  >
                    {page.hero.callToAction.link.title}
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="h-[150px] md:h-[33vh] lg:h-auto">
          {page.hero.leftImage && (
            <img
              src={urlBuilder(useSanityClient)
                .image(page.hero.leftImage)
                .auto('format')
                .url()}
              alt={page.hero.leftImage.altText || ' '}
              loading="lazy"
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                objectPosition: 'center',
              }}
            />
          )}
        </div>
        <div className="relative h-[150px] md:h-[33vh] lg:h-auto">
          <div className="text-white absolute -translate-y-[50%] text-center w-full lg:w-drawer-height lg:-rotate-90 lg:translate-y-[50%] lg:-translate-x-[50%] lg:bottom-[50%]">
            <IconTagLine className="max-w-full" />
          </div>
          {page.hero.rightImage && (
            <img
              src={urlBuilder(useSanityClient)
                .image(page.hero.rightImage)
                .auto('format')
                .url()}
              alt={page.hero.rightImage.altText || ' '}
              loading="lazy"
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                objectPosition: 'center',
              }}
            />
          )}
        </div>
      </div>
    );
  }

  return <></>;
}
